import { styled } from '@mui/material/styles';
import { Button } from 'shared/mui/Buttons';

export const FilterApplyButtonStyled = styled(Button)({
  width: '100%',
});
